import { render } from "./StartVirtualMachine.vue?vue&type=template&id=27bc9cce&scoped=true"
import script from "./StartVirtualMachine.vue?vue&type=script&lang=js"
export * from "./StartVirtualMachine.vue?vue&type=script&lang=js"

import "./StartVirtualMachine.vue?vue&type=style&index=0&id=27bc9cce&scoped=true&lang=less"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc9cce"]])

export default __exports__